import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
  FnTransferableArg,
} from "shared/provider-webworker";
import {
  IDetailedOrderStatusRequestService,
  CHANNEL_DETAILED_ORDER_STATUS_REQUEST,
} from "../IDetailedOrderStatusRequestService";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { TraderGroupLookupService } from "../../lookup/model/impl/TraderGroupLookupService";

import { Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { OrderQueryRequestPromiseService } from "./OrderQueryRequestPromiseService";
import { CHANNEL_ORDER_QUERY_REQUEST } from "../IOrderQueryRequestService";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class OrderQueryRequestReplicaService implements OrderQueryRequestPromiseService {
  protected broker: ClientMessageBroker;

  constructor(protected factory: ClientMessageBrokerFactory) {
    this.broker = this.factory.createMessageBroker(CHANNEL_ORDER_QUERY_REQUEST, true, true);
  }

  public request(orderQuery: CubiqTS.OrderQueryRequest): Promise<CubiqTS.StandardReport> {
    let request = new UiArguments("request");

    request.args = [new FnArg(orderQuery, CubiqTS.ENCODABLE(CubiqTS.OrderQueryRequestImpl))];

    return this.broker.runOnService(request, CubiqTS.ENCODABLE(CubiqTS.StandardReportImpl));
  }
}
